import Spinner from "@/components/spinner";
import { useQuestion } from "@/store/question.context";
import { formatDistanceToNow } from "date-fns";
import { useEffect, useState } from "react";

export const QuestionStatusDescription = () => {
  const [lastSavedTimeString, setLastSavedTimeString] = useState("");

  const { isSaving, lastSavedTime, isValidSelection, isDirty } = useQuestion();

  // Update the last saved time message
  useEffect(() => {
    const updateTimeString = () => {
      if (!lastSavedTime) {
        setLastSavedTimeString("");
        return;
      }

      const string = formatDistanceToNow(lastSavedTime, {
        addSuffix: true,
        includeSeconds: true,
      });

      setLastSavedTimeString(string);
    };

    const intervalId = setInterval(updateTimeString, 3000);

    updateTimeString();

    return () => clearInterval(intervalId);
  }, [lastSavedTime]);

  return (
    <div className="flex grow items-center text-xs text-muted-foreground">
      {isSaving ? (
        <span className="inline-flex items-center gap-2">
          <Spinner className="m-0 w-4" /> Guardando...
        </span>
      ) : (
        <>
          {isValidSelection && lastSavedTime && (
            <span>
              Guardada <time>{lastSavedTimeString}</time>.
            </span>
          )}

          {!isValidSelection && isDirty && (
            <span className="text-red-600">
              Selecciona una respuesta válida.
            </span>
          )}
        </>
      )}
    </div>
  );
};

export default QuestionStatusDescription;
